import React, { FC } from 'react';

import { WarningAlt } from '@yandex-360/iconostasis/dist/icons/WarningAlt';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { StatusCode as DeviceStatusCode } from '@yandex-video-platform/goloom-sdk';
import { useSelector } from 'react-redux';

import { i18n } from '../../../../../../../../helpers/i18n';
import { getAudioInputError } from '../../../../../../../device-manager/selectors';
import { DeviceErrorCode } from '../../../../../../../device-manager/types';
import { Heading } from '../../../../heading';
import css from '../styles.css';
import { InputDeviceLeveL } from './input-device-level';

const DEVICE_DENIED_ERRORS = new Set<DeviceErrorCode>([
    DeviceStatusCode.DEVICE_DENIED_BY_SYSTEM,
    DeviceStatusCode.DEVICE_DENIED_BY_USER,
]);
export const InputDeviceHeader: FC = () => {
    const isInputAudioDeviceError = useSelector(getAudioInputError);
    const isDevicePermissionError = isInputAudioDeviceError && DEVICE_DENIED_ERRORS.has(isInputAudioDeviceError);
    return (
        <div className={css.headingWrapper}>
            <Heading
                title={i18n('settings-v2', 'sound-microphone')}
                rightCustom={
                    isDevicePermissionError ? (
                        <div className={css.noAccessWrapper}>
                            <WarningAlt size="sm" variant="outline" className={css.noAccessIcon} />
                            <Text typography="body-md-regular">
                                {i18n('settings-v2', 'diagnostic-device-permission-denied')}
                            </Text>
                        </div>
                    ) : (
                        <InputDeviceLeveL />
                    )
                }
            />
        </div>
    );
};
